<template>
  <div class="px-sm-4">
    <b-card body-class="p-md-1 p-0">
      <b-card-header class="align-items-start flex-sm-row flex-column-reverse">
        <b-card-title class="mt-sm-0 mt-2">
          <h5 class="mb-1 text-white">
            {{ $route.params.id ? "Edit account" : "Create account" }}
          </h5>
        </b-card-title>

        <b-link :to="{ name: 'accounts' }">
          <span>back to the account list </span>
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="createForm">
          <b-form class="form mt-2" @submit.prevent="createForm">
            <b-row>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="number"
                  class="w-100"
                  label="Account number"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="number"
                    rules="required"
                  >
                    <b-form-input
                      id="number"
                      v-model="number"
                      min="1"
                      type="number"
                      name="number"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="name"
                  class="w-100"
                  label="Account name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="username"
                      name="name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->

              <b-col class="d-flex" lg="4">
                <b-form-group
                  label="Investor password"
                  label-for="investor_password"
                  class="w-100"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Investor password"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="investor_password"
                        v-model="password"
                        :type="cpasswordFieldType"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        name="investor_password"
                        placeholder="············"
                        autocomplete="on"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="cpasswordToggleIcon"
                          class="cursor-pointer"
                          @click="toggleCpasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col class="d-flex" lg="4">
                <b-form-group label-for="broker" class="w-100" label="Broker">
                  <validation-provider
                    #default="{ errors }"
                    name="broker"
                    rules="required"
                  >
                    <select-box
                      v-model="broker_id"
                      label="text"
                      select="id"
                      searchable
                      url="broker"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col class="d-flex align-items-center my-2" lg="4">
                <b-form-group
                  class="w-100 d-flex align-items-center mb-0 warning-button"
                >
                  <b-form-checkbox
                    v-model="active"
                    name="active"
                    switch
                    inline
                    :uncheckedValue="0"
                    :value="1"
                  >
                    active
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="d-flex align-items-center justify-content-end">
              <b-button class="gradient-btn" type="submit"> submit </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButtonGroup,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BFormTextarea,
  BMedia,
  BAvatar,
  BImg,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButtonGroup,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
    SelectBox,
    BFormTextarea,
    BMedia,
    BAvatar,
    BImg,
  },
  data() {
    return {
      username: "",
      password: "",
      broker_id: "",
      number: "",
      active: 1,
      loading: false,
      // validation rules
      required,
    };
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  created() {
    if (this.$route.params.id) {
      this.getAccount();
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    cpasswordToggleIcon() {
      return this.cpasswordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    async getAccount() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/accounts/${this.$route.params.id}`
        );
        if (data.data.editable) {
          await Object.keys(data.data).map((item) => {
            if (item == "active") {
              this[item] = data.data[item] ? 1 : 0;
            } else if (item == "username") {
              this[item] = data.data.username;
              this["number"] = data.data.username;
            } else {
              this[item] = data.data[item];
            }
          });
        } else {
          this.$router.push("/accounts");
        }
      } catch (err) {}
      this.loading = false;
    },
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            this.formData = await new FormData();
            let newObject = await {
              password: this.password,
              broker_id: this.broker_id,
              username: this.number,
              active: this.active,
            };

            await Object.keys(newObject).map((item, index) => {
              this.setFormData(newObject[item], index, item);
            });

            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `panel/accounts/${this.$route.params.id}?_method=put`,
                this.formData
              );
              await this.getAccount();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Account Updated",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              const { data } = await this.$http.post(
                "panel/accounts",
                this.formData
              );
              this.$router.push({ name: "accounts" });
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>
